import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { SalesItemField } from "../../../_statics/RuleStatics";
import { sortEnumValues } from "../../../../_services/sorting-helper";

export const DropdownEnumOptionsOld = ({
    enumListName,
    enumIdentifier,
    listOfEnumIdentifier,
    showDebitorMailOption,
    showDiscountTypeOptions = false,
    showProductMetafieldMatching,
    sorted = true,
    exclude = [],
}) => {
    const allEnumSelectors = useSelector((state) => state.commons.salesRuleSelectors);

    const enumSelector = useMemo(
        () => allEnumSelectors[enumListName].find((item) => item.enumIdentifier === enumIdentifier),
        [enumListName, enumIdentifier, allEnumSelectors]
    );

    const enumSelectors = useMemo(() => {
        if (listOfEnumIdentifier != null) {
            let filteredEnumSelectors = allEnumSelectors[enumListName].filter((enumSelector) =>
                listOfEnumIdentifier.includes(enumSelector.enumIdentifier)
            );

            if (!showDiscountTypeOptions) {
                filteredEnumSelectors = filteredEnumSelectors.filter(
                    (enumSelector) =>
                        enumSelector.enumIdentifier !== SalesItemField.PLATFORM_DISCOUNT_TYPE &&
                        enumSelector.enumIdentifier !== SalesItemField.SELLER_DISCOUNT_TYPE
                );
            }

            if (!showDebitorMailOption) {
                filteredEnumSelectors = filteredEnumSelectors.filter(
                    (enumSelector) => enumSelector.enumIdentifier !== SalesItemField.DEBITOR_MAIL
                );
            }
            if (!showProductMetafieldMatching) {
                filteredEnumSelectors = filteredEnumSelectors.filter(
                    (enumSelector) =>
                        enumSelector.enumIdentifier !== SalesItemField.METAFIELD_PRODUCT &&
                        enumSelector.enumIdentifier !== SalesItemField.METAFIELD_PRODUCT_VARIANT
                );
            }
            return filteredEnumSelectors;
        }

        return null;
    }, [
        listOfEnumIdentifier,
        enumListName,
        allEnumSelectors,
        showDiscountTypeOptions,
        showDebitorMailOption,
        showProductMetafieldMatching,
    ]);

    let selectedValues = enumSelector
        ? [enumSelector]
        : listOfEnumIdentifier && enumSelectors
          ? enumSelectors
          : allEnumSelectors[enumListName];

    if (exclude && exclude.length > 0) {
        selectedValues = selectedValues.filter((value) => {
            return !exclude.includes(value.enumIdentifier);
        });
    }

    if (sorted) {
        selectedValues = sortEnumValues(selectedValues);
    }

    return selectedValues.map((item, index) => (
        <option key={index} value={item.enumIdentifier}>
            {item.enumDescription}
        </option>
    ));
};

export const DropdownEnumOptions = ({
    enumListName,
    enumIdentifier,
    listOfEnumIdentifier,
    sorted = true,
    exclude = [],
    showDiscountTypeOptions = false,
}) => {
    const allEnumSelectors = useSelector((state) => state.commons.salesRuleSelectors);

    const enumSelector = useMemo(() => {
        return allEnumSelectors[enumListName].find((item) => item.enumIdentifier === enumIdentifier);
    }, [allEnumSelectors, enumListName, enumIdentifier]);

    const enumSelectors = useMemo(() => {
        if (listOfEnumIdentifier != null) {
            let filteredEnumSelectors = allEnumSelectors[enumListName].filter((enumSelector) =>
                listOfEnumIdentifier.includes(enumSelector.enumIdentifier)
            );

            if (!showDiscountTypeOptions) {
                filteredEnumSelectors = filteredEnumSelectors.filter(
                    (enumSelector) =>
                        enumSelector.enumIdentifier !== SalesItemField.PLATFORM_DISCOUNT_TYPE &&
                        enumSelector.enumIdentifier !== SalesItemField.SELLER_DISCOUNT_TYPE
                );
            }

            return filteredEnumSelectors;
        }

        return null;
    }, [listOfEnumIdentifier, allEnumSelectors, showDiscountTypeOptions, enumListName]);

    let selectedValues = enumSelector
        ? [enumSelector]
        : listOfEnumIdentifier && enumSelectors
          ? enumSelectors
          : allEnumSelectors[enumListName];

    if (exclude && exclude.length > 0) {
        selectedValues = selectedValues.filter((value) => {
            return !exclude.includes(value.enumIdentifier);
        });
    }

    if (sorted) {
        selectedValues = sortEnumValues(selectedValues);
    }

    return selectedValues.map((item, index) => (
        <option key={index} value={item.enumIdentifier}>
            {item.enumDescription}
        </option>
    ));
};

export const ContentEnumOptions = ({ enumIdent }) => {
    const [enumDescriptionToDisplay, setEnumDescriptionToDisplay] = useState(null);
    const [propsInState, setPropsInState] = useState();

    const allEnumSelectors = useSelector((state) => state.commons.salesRuleSelectors);

    useEffect(() => {
        if (allEnumSelectors != null) {
            setPropsInState(Object.getOwnPropertyNames(allEnumSelectors));
        }
    }, [allEnumSelectors]);

    useEffect(() => {
        let updatedOptions = [];
        if (enumIdent && propsInState != null) {
            propsInState.forEach((prop) => {
                updatedOptions = [...updatedOptions, ...allEnumSelectors[prop]];
            });
            setEnumDescriptionToDisplay(updatedOptions.find((enumInList) => enumInList.enumIdentifier === enumIdent));
        } else {
            setEnumDescriptionToDisplay(null);
        }
    }, [enumIdent, propsInState, allEnumSelectors]);
    return enumDescriptionToDisplay !== null ? <>{enumDescriptionToDisplay.enumDescription}</> : null;
};

const ACCOUNTING_IDENTIFIER_FIELD = "accountingIdentifierField";
const SELECTABLE_SALES_ITEM_FIELD = "selectableSalesItemField";
const SALES_ITEM_MATCHER = "salesItemMatcher";
const VAT_MAPPING_RULE = "vatMappingRule";
const SALES_RULE_REVENUE_TYPE = "salesRuleRevenueType";
const COUNTRY_TYPE_MATCHING_VALUE = "countryTypeMatchingValue";

export const EnumListNames = {
    ACCOUNTING_IDENTIFIER_FIELD,
    SELECTABLE_SALES_ITEM_FIELD,
    SALES_ITEM_MATCHER,
    VAT_MAPPING_RULE,
    SALES_RULE_REVENUE_TYPE,
    COUNTRY_TYPE_MATCHING_VALUE,
};
